import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AbilityService } from '../../../_shared/services/ability.service';
import { UtilService } from '../../../_shared/services/util.service';

import { LanguageService } from '../../../languages/shared/language.service';

import { Location } from '../../shared/location.model';
import { LocationService } from '../../shared/location.service';
import { LocationListComponent } from '../../location-list/location-list.component';
import { LocationDetailComponent } from '../../location-detail/location-detail.component';

@Component({
  selector: 'app-locations-modal',
  templateUrl: './locations-modal.component.html',
  standalone: true,
  imports: [SharedModule, LocationListComponent, LocationDetailComponent],
})
export class LocationsModalComponent {
  modalTitle = this.data.title;

  locations: Location[];
  meta = [];
  location: Location;
  mode = '';
  loadingLocations = false;

  listMode = true;
  detailMode = false;

  permissions = {
    canList: this.abilityService.can('index_location_accountadmin'),
    canCreate: this.abilityService.can('create_location_accountadmin'),
  };

  defaultLanguage: any;

  private filterCriteria = this.locationService.getFilterCriteria();
  additionalLanguages = [];

  constructor(
    private locationService: LocationService,
    private languageService: LanguageService,
    private abilityService: AbilityService,
    private utilService: UtilService,
    private ref: MatDialogRef<LocationsModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getAdditionalLanguages();
  }

  showLocations() {
    this.listMode = true;
    this.detailMode = false;

    this.getLocations();
  }

  addLocation() {
    this.modalTitle = 'ADD_ZONE';
    this.listMode = false;
    this.detailMode = true;

    this.location = { name: '' };
  }

  // Referenced from app-location-detail
  onSavedLocation(location) {
    this.location = location;

    this.listMode = true;
    this.detailMode = false;

    this.getLocations(location);
  }

  // Referenced from app-location-detail
  onCanceledLocation() {
    this.showLocations();
  }

  close() {
    this.ref.close(true); // close the dialog
  }

  // Referenced from app-location-list
  onSelectedLocation({ location, mode = '' }) {
    this.mode = mode;

    this.modalTitle = 'ZONE_DETAILS';
    this.listMode = false;
    this.detailMode = true;

    this.getLocation(location.id);
  }

  private getLocations(selectedLocation = null) {
    this.filterCriteria.lang = this.defaultLanguage.lang;

    this.loadingLocations = true;
    this.locationService.getLocations(this.filterCriteria).subscribe((response) => {
      this.locations = response.data;
      this.meta = response.meta;

      this.loadingLocations = false;

      if (selectedLocation) {
        this.utilService.changeItemRowStyle(selectedLocation.id);
      }
    });
  }

  private getLocation(locationId) {
    this.location = null;

    this.locationService.getLocation(locationId).subscribe((response) => {
      this.location = response;
    });
  }

  private getAdditionalLanguages() {
    this.languageService.getLanguages({ skip_check_role: true }).subscribe((response) => {
      this.defaultLanguage = response.data.find((language) => language.is_default);
      this.additionalLanguages = response.data.filter((language) => !language.is_default);

      this.getLocations();
    });
  }
}
